module.exports = __webpack_public_path__ + "img/4.9ed73cd7.png";